import { Building2Icon, HardDriveIcon, UsersRoundIcon } from 'lucide-react';
import { useTranslation } from 'react-i18next';

import type { IconComponent } from '@/shared/registry/types';

import type { Storage, StorageKind } from '../api';

/** Glyph of each kind of drive. */
export const STORAGE_ICONS: Record<StorageKind, IconComponent> = {
  user: HardDriveIcon,
  company: Building2Icon,
  group: UsersRoundIcon,
};

/** Display name of a drive: "Мой диск", "Общий диск", the group's name, "Диск: <owner>". */
export function useStorageName() {
  const { t } = useTranslation('disk');
  return (storage: Pick<Storage, 'kind' | 'group' | 'owner'>, myUserId?: string): string => {
    if (storage.kind === 'company') return t('storages.company');
    if (storage.kind === 'group') return storage.group?.name ?? t('storages.group');
    if (!storage.owner || storage.owner.id === myUserId) return t('storages.my');
    return t('storages.userDrive', { name: storage.owner.fullName });
  };
}
